export const getMargin = (profit, revenue) => {
  const margin = revenue > 0 ? (profit / revenue) * 100 : 0;
  return margin < -100 ? -100 : margin;
};
